import axiosInstance from '../utils/setupAxios';

const PREFIX = '/songs/explore';

const toFormData = (obj) => {
  const fd = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value instanceof File) {
      fd.append(key, value, value.name);
    } else if (Array.isArray(value)) {
      value.forEach((v, i) => fd.append(`${key}[${i}]`, v));
    } else if (typeof value === 'boolean') {
      fd.append(key, value ? '1' : '0');
    } else {
      fd.append(key, value);
    }
  });
  return fd;
};

// Admin APIs
export const getExploreStats = () =>
  axiosInstance.get(`${PREFIX}/admin/stats`);

export const getPublicSongs = (params) =>
  axiosInstance.get(`${PREFIX}/admin/public-songs`, { params });

export const updateSongVisibility = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/public-song`, toFormData(payload));

export const getAdminPlaylists = (params) =>
  axiosInstance.get(`${PREFIX}/admin/playlists`, { params });

export const getMyPlaylists = (params) =>
  axiosInstance.get(`${PREFIX}/my-playlists`, { params });

export const getMySongs = (params) =>
  axiosInstance.get('/songs/users/my-songs', { params });

export const createPlaylist = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists`, toFormData(payload));

export const updatePlaylist = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/update`, toFormData(payload));

export const deletePlaylist = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/delete`, toFormData(payload));

export const addSongToPlaylist = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/add-song`, toFormData(payload));

export const removeSongFromPlaylist = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/remove-song`, toFormData(payload));

export const reorderPlaylistSongs = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/reorder-songs`, toFormData(payload));

export const generatePlaylistThumbnail = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/generate-thumbnail`, payload);

export const applyPlaylistThumbnail = (payload) =>
  axiosInstance.post(`${PREFIX}/admin/playlists/apply-thumbnail`, payload);

// Public APIs (no auth required, but admin dashboard may still send token)
export const getExplorePlaylists = (params) =>
  axiosInstance.get(`${PREFIX}/playlists`, { params });

export const getExplorePlaylistDetail = (params) =>
  axiosInstance.get(`${PREFIX}/playlists/detail`, { params });

export const getNewReleases = (params) =>
  axiosInstance.get(`${PREFIX}/new-releases`, { params });

export const getTopCharts = (params) =>
  axiosInstance.get(`${PREFIX}/top-charts`, { params });

export const recordPlay = (payload) =>
  axiosInstance.post(`${PREFIX}/play`, toFormData(payload));

export const getExploreTags = (params) =>
  axiosInstance.get(`${PREFIX}/tags`, { params });

export const getExploreSongs = (params) =>
  axiosInstance.get(`${PREFIX}/songs`, { params });
